import React, { useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import FollowUs from "../Footer/FollowUs";
import LetsGet from "../Footer/LetsGet";
import { motion } from "framer-motion";

const WorkPage = () => {
  const [filter, setFilter] = useState("All");


const fadeRight = {
  hidden: { opacity: 0, x: 80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 1.6, ease: "easeOut" },
  },
};

const fadeLeft = {
  hidden: { opacity: 0, x: -80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 1.6, ease: "easeOut" },
  },
};

const text = "OUR WORK SPEAKS BEFORE WE DO";

// const fadeRight = {
//   hidden: { opacity: 0, x: 80 },
//   visible: {
//     opacity: 1,
//     x: 0,
//     transition: { duration: 0.9, ease: "easeOut" },
//   },
// };

  return (
    <div className="overflow-x-hidden">
      <Header />

      <div className="w-full bg-white py-28">
        <div className="max-w-7xl mx-auto px-6">

          <div className="text-center mb-16">
            <p className="montserrat text-[#F56E0F] text-md tracking-widest uppercase font-medium">
              Our Works
            </p>

            {/* <h2 className="text-4xl mt-4 heading">
              OUR WORK SPEAKS BEFORE WE DO
            </h2> */}
             <motion.h2
                className="text-4xl mt-4 heading"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                {text.split("").map((char, index) => (
                  <motion.span
                    key={index}
                    variants={{
                      hidden: { opacity: 0 },
                      visible: { opacity: 1 },
                    }}
                    transition={{
                      delay: index * 0.07,
                      duration: 0.04,
                    }}
                  >
                    {char}
                  </motion.span>
                ))}
              </motion.h2>

            <p className="text-black montserrat max-w-3xl mx-auto mt-4">
              Every project at Open Studios is built on strategy, creativity, and purpose. From high-impact visuals to
               performance-driven campaigns, our work reflects the brands we partner with and the goals we help them achieve. 
            </p>
          </div>

          <div className="flex items-center justify-between mb-20">
            <div>
              <h3 className="text-3xl font-semibold">Choose from.</h3>
              <div className="text-2xl mt-2">↓</div>
            </div>

            {/* <select
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className="border-b border-black bg-transparent focus:outline-none text-lg montserrat"
            >
              <option value="All">All</option>
              <option value="Social Media Management">Social Media Management</option>
              <option value="Branding">Branding</option>
              <option value="UI/UX">UI/UX</option>
            </select> */}
            <select
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                className="border-b border-black bg-transparent focus:outline-none text-lg montserrat w-full md:w-72 pb-2 cursor-pointer"
                >
                <option value="All">All</option>
                <option value="Social Media Management">Social Media Management</option>
                <option value="Branding">Branding</option>
                <option value="UI/UX">UI/UX</option>
                </select>
          </div>

          <div className="space-y-20">

            {/* PROJECT 01 */}
            {(filter === "All" || filter === "Social Media Management") && (
              <div>
                {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
                  <div className="space-y-4 montserrat">
                    <p className="text-sm text-black mb-10">
                      01 / PROJECT NAME
                    </p>

                    <p className="text-black max-w-md">
                      Goblin concept digital sculpture with human-like skin. Learned a lot of quick tips and look development.
                    </p>
                    <p className="text-[#606060] max-w-md bodyFont">
                        Sculpted in ZBrush, Retopologized and UVs done in Maya, Textured in Mari, Rendered using Arnold.
                    </p>

                    <button className="text-black underline underline-offset-4">
                      More shots from this project →
                    </button>
                  </div>

                  <div className="w-full h-72 bg-gray-600 rounded-lg"></div>
                </div> */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24 items-start py-12">
                    {/* <div className="flex flex-col space-y-6 montserrat"> */}
                      <motion.div
                                  variants={fadeLeft}
                                  initial="hidden"
                                  whileInView="visible"
                                  viewport={{ once: true }}
                                  className="flex flex-col space-y-6 montserrat"
                      >  
                        <h3 className="text-sm font-bold tracking-tight text-black mb-0">
                        01 / PROJECT NAME
                        </h3>

                        <p className="text-xl leading-snug text-black max-w-sm">
                        Goblin concept digital sculpture with human-like skin. Learned a lot of quick tips and look development.
                        </p>

                        <p className="text-[13px] leading-relaxed text-[#808080] max-w-xs pt-4 bodyFont">
                        Sculpted in ZBrush, Retopologized and UVs done in Maya, Textured in Mari. Rendered using Arnold.
                        </p>

                        <div className="pt-16">
                        <button className="text-sm font-semibold text-black underline underline-offset-8 hover:opacity-70 transition-opacity">
                            More shots from this project →
                        </button>
                        </div>
                        </motion.div>
                    {/* </div> */}

                    {/* <div className="w-full h-80 bg-[#666666] rounded-[20px]"></div> */}
                  
                  <motion.div
                              variants={fadeRight}
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true }}
                            >
                  <img
                      src="https://media.istockphoto.com/id/1443245439/photo/business-meeting-businesswoman-woman-office-portrait-job-career-happy-businessman-teamwork.jpg?s=612x612&w=0&k=20&c=1ZR02c1UKfGdBCNWzzKlrwrVZuEiOqnAKcKF4V_t038="
                      alt="img"
                      className="w-full h-80 object-cover bg-[#666666] rounded-[20px]"
                  /></motion.div>  
                  </div>
                <div className="border-b border-gray-300 mt-10"></div>
              </div>
            )}

            {/* PROJECT 02 */}
            {(filter === "All" || filter === "Branding") && (
              <div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24 items-start py-12">
                    {/* <div className="flex flex-col space-y-6 montserrat"> */}
                    <motion.div
                                  variants={fadeLeft}
                                  initial="hidden"
                                  whileInView="visible"
                                  viewport={{ once: true }}
                                  className="flex flex-col space-y-6 montserrat">
                        <h3 className="text-sm font-bold tracking-tight text-black mb-0">
                        02 / PROJECT NAME
                        </h3>

                        <p className="text-xl leading-snug text-black max-w-sm">
                        Subsurface weight, specular roughness, diffuse maps generated with the procedure and manual techniques.
                        </p>

                        <div className="pt-16">
                        <button className="text-sm font-semibold text-black underline underline-offset-8 hover:opacity-70 transition-opacity">
                           See case study →
                        </button>
                        </div>
                        </motion.div>
                    {/* </div> */}

                    {/* <div className="w-full h-80 bg-[#666666] rounded-[20px]"></div> */}
                     <motion.div
                              variants={fadeRight}
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true }}
                            >
                    <img
                      src="https://media.istockphoto.com/id/1443245439/photo/business-meeting-businesswoman-woman-office-portrait-job-career-happy-businessman-teamwork.jpg?s=612x612&w=0&k=20&c=1ZR02c1UKfGdBCNWzzKlrwrVZuEiOqnAKcKF4V_t038="
                      alt="img"
                      className="w-full h-80 object-cover bg-[#666666] rounded-[20px]"
                    /></motion.div>
                    </div>

                <div className="border-b border-gray-300 mt-10"></div>
              </div>
            )}

            {/* PROJECT 03 */}
            {(filter === "All" || filter === "UI/UX") && (
            <div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24 items-start py-12">
                    {/* <div className="flex flex-col space-y-6 montserrat"> */}
                        <motion.div
                                  variants={fadeLeft}
                                  initial="hidden"
                                  whileInView="visible"
                                  viewport={{ once: true }}
                                  className="flex flex-col space-y-6 montserrat">
                        <h3 className="text-sm font-bold tracking-tight text-black mb-0">
                        03 / PROJECT NAME
                        </h3>

                        <p className="text-xl leading-snug text-black max-w-sm">
                        Experimental creature modeling for school project.
                        </p>

                        <div className="pt-32">
                        <button className="text-sm font-semibold text-black underline underline-offset-8 hover:opacity-70 transition-opacity">
                           See case study →
                        </button>
                        </div>
                        </motion.div>
                    {/* </div> */}

                    {/* <div className="w-full h-80 bg-[#666666] rounded-[20px]"></div> */}
                    
                  <motion.div
                              variants={fadeRight}
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true }}
                            >
                    <img
                      src="https://media.istockphoto.com/id/1443245439/photo/business-meeting-businesswoman-woman-office-portrait-job-career-happy-businessman-teamwork.jpg?s=612x612&w=0&k=20&c=1ZR02c1UKfGdBCNWzzKlrwrVZuEiOqnAKcKF4V_t038="
                      alt="img"
                      className="w-full h-80 object-cover bg-[#666666] rounded-[20px]"
                    /></motion.div>
                    </div>

                <div className="border-b border-gray-300 mt-10"></div>
              </div>
            )}

          </div>

        </div>
      </div>
            <LetsGet />
            <FollowUs />   
            <Footer />
    </div>
  );
};

export default WorkPage;
